import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const UsersIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.text.default,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 7.81818C7.76731 7.81818 9.2 6.51574 9.2 4.90909C9.2 3.30244 7.76731 2 6 2C4.23269 2 2.8 3.30244 2.8 4.90909C2.8 6.51574 4.23269 7.81818 6 7.81818ZM6 6.72727C7.10457 6.72727 8 5.91325 8 4.90909C8 3.90494 7.10457 3.09091 6 3.09091C4.89543 3.09091 4 3.90494 4 4.90909C4 5.91325 4.89543 6.72727 6 6.72727Z"
          fill={color}
        />
        <path
          d="M10.4455 2.00846C10.1151 1.98561 9.82687 2.21059 9.80173 2.51096C9.7766 2.81134 10.0241 3.07337 10.3545 3.09622C11.3866 3.1676 12.2 3.95224 12.2 4.90909C12.2 5.86593 11.3866 6.65058 10.3545 6.72195C10.0241 6.7448 9.7766 7.00683 9.80173 7.30721C9.82687 7.60759 10.1151 7.83257 10.4455 7.80972C12.0984 7.69541 13.4 6.44069 13.4 4.90909C13.4 3.37748 12.0984 2.12276 10.4455 2.00846Z"
          fill={color}
        />
        <path
          d="M3 9.27273C1.34315 9.27273 0 10.4938 0 12V13.4545C0 13.7558 0.268629 14 0.6 14C0.931371 14 1.2 13.7558 1.2 13.4545V12C1.2 11.0963 2.00589 10.3636 3 10.3636H9C9.99411 10.3636 10.8 11.0963 10.8 12V13.4545C10.8 13.7558 11.0686 14 11.4 14C11.7314 14 12 13.7558 12 13.4545V12C12 10.4938 10.6569 9.27273 9 9.27273H3Z"
          fill={color}
        />
        <path
          d="M13 9.27273C12.6686 9.27273 12.4 9.51694 12.4 9.81818C12.4 10.1194 12.6686 10.3636 13 10.3636C13.9941 10.3636 14.8 11.0963 14.8 12V13.4545C14.8 13.7558 15.0686 14 15.4 14C15.7314 14 16 13.7558 16 13.4545V12C16 10.4938 14.6569 9.27273 13 9.27273Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
